import { Graph, GraphData } from 'dashboard/models/graph';
import Action from 'lib/interfaces/Action';

export type GraphActions =
  | Action<GraphActionType.SetGraph, GraphPayload>
  | Action<GraphActionType.SetGraphs, GraphsPayload>
  | Action<GraphActionType.ClearGraphData>
  | Action<GraphActionType.SetGraphData, GraphDataPayload>;

export enum GraphActionType {
  SetGraph = 'graph/SET_GRAPH',
  SetGraphs = 'graph/SET_GRAPHS',
  ClearGraphData = 'graph/CLEAR_GRAPH_DATA',
  SetGraphData = 'graph/SET_GRAPH_DATA',
}

interface GraphPayload {
  graph: Graph;
}

export function setGraph(graph: Graph): Action<GraphActionType.SetGraph, GraphPayload> {
  return {
    type: GraphActionType.SetGraph,
    payload: { graph },
  };
}

interface GraphsPayload {
  graphs: Graph[];
}

export function setGraphs(graphs: Graph[]): Action<GraphActionType.SetGraphs, GraphsPayload> {
  return {
    type: GraphActionType.SetGraphs,
    payload: { graphs },
  };
}

export function clearGraphData(): Action<GraphActionType.ClearGraphData> {
  return { type: GraphActionType.ClearGraphData };
}

interface GraphDataPayload {
  graphData: GraphData;
}

export function setGraphData(
  graphData: GraphData,
): Action<GraphActionType.SetGraphData, GraphDataPayload> {
  return {
    payload: {
      graphData,
    },
    type: GraphActionType.SetGraphData,
  };
}
